import { OUT_REACH_MODULE } from "@/helperMethods/outreach";

export const moduleDescriptions = {
  // Core Access & Security
  access_control:
    "OAuth/JWT authentication system managing dashboard user roles, permissions, and departmental access hierarchies",
  agents:
    "Access level management for agent-related modules including livechat handover, supervisor oversight, and departmental agent assignments",
  audit:
    "Comprehensive tracking system for changes, dashboard user actions, and system activity ensuring compliance and accountability",
  authorize_widget:
    "Pre-authentication workflow engine enabling seamless user experiences within embedded AI widgets for post-login scenarios",

  // AI & Analytics
  analytics:
    "Advanced insights engine providing performance metrics, user interaction patterns, and usage trend analysis with detailed reporting dashboards",
  genai:
    "Generative AI management suite with persona profile editor, pre/post action workflows, prompt engineering tools, and integrated knowledge base management",
  evaluation:
    "AI model testing and optimization framework supporting Rasa/LUIS integration with benchmark scoring and dataset validation",
  entities:
    "Structured data recognition system defining key terms, objects, and fields for AI comprehension and workflow automation",

  // Content & Knowledge Management
  faq: "Multi-engine Q&A system supporting Rasa/Watson/ELSA with dynamic FAQ management for AI-powered responses",
  knowledge_base:
    "Structured knowledge repository serving as training source and reference base for GenAI",
  documentation:
    "Technical and user-facing documentation generation, storage, and management system",
  "file-storage":
    "Secure file management infrastructure for documents, assets, and media used by AI workflows",

  // Communication & Engagement
  broadcast:
    "Targeted messaging system for bulk campaigns and AI-generated communications to segmented user groups",
  livechat:
    "Human agent handover system with GraphQL integration enabling seamless AI-to-human conversation transitions",
  whatsapp: "WhatsApp Business API integration for AI chatbot deployment with message management",
  whatsapp_checker:
    "Approval workflow system for WhatsApp bulk message campaigns and content validation",
  webchat:
    "Embeddable GenAI-powered chat widget for website deployment with customizable interfaces",
  [OUT_REACH_MODULE]:
    "Campaign management for multi-channel user engagement via email, SMS, and messaging platforms",
  "outreach-admin":
    "Administrative dashboard for campaign management, scheduling, and audience targeting",

  // Workflow & Development
  editor: "Visual conversational flow builder for AI workflow design, testing, and refinement",
  editor_approve:
    "Content approval workflow system ensuring production-ready changes through review processes",
  developer: "REST API access, SDK tools, and integration capabilities for platform customization",
  import_export: "Configuration management for workflow portability and reuse across environments",

  // Forms & Data Collection
  chat_form: "Conversational form designer for structured data capture during user interactions",

  // User & System Management
  users: "Platform user management including profiles, access levels, and permission assignments",
  visitors: "Real-time visitor tracking and monitoring for AI interaction analytics",
  clone_user: "User profile duplication system for accelerated onboarding and testing scenarios",
  settings:
    "System-wide configuration management for preferences, integrations, and AI behavior defaults",
  subscription: "Social media subscription and channel management system",
  supervisor: "Agent performance oversight and management dashboard",

  // Specialized Features
  ecare:
    "Enhanced AI-driven customer care and self-service experience platform (replaces customer_care)",
  games: "Interactive AI-driven experiences and gamified learning module creation",
  labs: "Experimental feature testing environment for prototypes and beta functionality",
  prism: "Real-time data visualization and monitoring dashboard for AI workflows and interactions",
  scribe: "Automated conversation transcription, annotation, and documentation system",
  webpage_checker: "Content approval system for webpage validation in AI workflows",

  // Additional modules (not documented - keeping original descriptions)
  alerts: "Set up notification alerts and triggers",
  ameyo: "Ameyo contact center integration",
  article: "Article management system",
  audio: "Audio processing and management",
  azure: "Microsoft Azure integration services",
  bookworm: "Document and content reading system",
  calendly: "Calendly scheduling integration",
  cention: "Cention contact center integration",
  ciscoEce: "Cisco Enterprise Chat and Email integration",
  core: "Core system functionality",
  customer_care: "Customer care and support tools",
  email: "Email processing and management",
  emotion: "Emotion detection and analysis",
  export: "Data export functionality",
  facebook: "Facebook Messenger integration",
  fallback: "Fallback response handling",
  faq2: "Multi-engine Q&A system supporting Rasa/Watson/ELSA with dynamic FAQ management for AI-powered responses",
  faqw: "Multi-engine Q&A system supporting Rasa/Watson/ELSA with dynamic FAQ management for AI-powered responses",
  fasttext: "FastText NLP processing",
  filePurge: "File cleanup and purging system",
  floweditor: "Conversation flow editor",
  form: "Form building and management",
  gateway: "API gateway and routing",
  genesys: "Genesys contact center integration",
  google_maps: "Google Maps integration",
  googlemaps: "Google Maps services",
  handover: "Live agent handover functionality",
  imagePurge: "Image cleanup and purging system",
  infobip: "Infobip messaging platform integration",
  infermedica: "Infermedica medical AI integration",
  line: "LINE messaging platform integration",
  luis: "Microsoft LUIS natural language understanding",
  makerChecker: "Maker-checker approval workflow",
  menu: "Menu and navigation management",
  moobidesk: "Moobidesk helpdesk integration",
  notification: "Push notifications and alerts",
  openai: "OpenAI API integration",
  organization: "Organization and tenant management",
  people: "People and contacts management",
  pii: "Personal Identifiable Information handling",
  postchatform: "Post-chat feedback forms",
  prechatform: "Pre-chat information forms",
  press: "Press and media management",
  press_release: "Press release publishing",
  pretrained_skills: "Pre-trained AI skills and models",
  rating: "Rating and feedback system",
  search: "Search functionality",
  services: "External services integration",
  singpass: "Singapore SingPass authentication",
  smartclassifier: "Smart content classification",
  synthesia: "Synthesia video generation",
  system: "System administration tools",
  teams: "Microsoft Teams integration",
  telegram: "Telegram messaging integration",
  templates: "Message templates management",
  tnc: "Terms and conditions management",
  translate: "Language translation services",
  twilio: "Twilio communication platform",
  twitter: "Twitter integration",
  uccx: "Cisco UCCX integration",
  viber: "Viber messaging integration",
  voice: "Voice processing and synthesis",
  webpage_editor: "Web page content editor",
  webex: "Cisco Webex integration",
  wechat: "WeChat messaging integration",
  workplace: "Facebook Workplace integration",
  yoursingapore: "YourSingapore tourism integration",
  zendesk: "Zendesk helpdesk integration",
  zoom: "Zoom video conferencing integration",
  what_news: "",
  manual: "",
};
